import { Component } from "react"

/* Components */
import { GameFilter, GameList, Layout } from "../../components"

/* Helpers */
import { utils } from "../../helpers"

/* REST API */
import { games } from "../../api/PuntoBanco"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"




/* THE TONE OF EVERY WINNER OF A ROUND */
const WINNERS = {
    player: "blue",
    banker: "red",
    tie: "green",
}

/* THE COLUMNS OF THE LIST — THE NUMBER, THE DATE AND THE STAR OF A ROUND BELONG TO THE LIST ITSELF */
const COLUMNS = () => [
    { key: "dealer", text: t("widget.dealer") },
    { key: "players", text: t("widget.players") },
    { key: "win", text: t("widget.winner"), render: (item) => WINNERS[item.win] ? <div className={`gl--badge ${WINNERS[item.win]}`}>{`${item.win}`.toUpperCase()}</div> : null },
    { key: "status", text: t("widget.status"), type: "status", flex: 1.2 },
    { key: "ggr", text: "GGR", type: "money" },
]

/* Widget Punto Banco Games */
class Games extends Component {

    constructor() {
        super()

        const date = utils.getDate()

        this.state = {
            data: [],
            status: "loading",
            page: 1,
            count: 0,
            number: "",
            startDate: date.startDate,
            endDate: date.endDate,
            savedOnly: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Reload Action — the page asks for it when the card of a round closes */
    reloadGames = () => {
        this.load(1, true)
    }

    /* Load Games list */
    load = (page = 1, reload = false) => {

        /* Fields */
        const { number, startDate, endDate, savedOnly } = this.state
        const start = moment(startDate).format("YYYY-MM-DD HH:mm:ss")
        const end = moment(endDate).format("YYYY-MM-DD HH:mm:ss")
        const { uid, postfix } = this.props

        /* Check Params */
        if (!uid) {
            this.setState({ status: "error", data: [] })
            return
        }

        /* Save Page */
        this.setState({ page })

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        games({ uid, page, number, start, end, postfix, savedOnly }).then((response) => {
            if (response.status === 200) {
                window.scroll({ top: 0 })
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [], count: 0 })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [], count: 0 })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [], count: 0 })
        })

    }

    /* Set Number Action */
    setNumber = (number) => {
        if (number === "") {
            this.setState({ number }, () => this.load(1))
        }
        else {
            this.setState({ number })
        }
    }

    /* Draw Round Winner */

    render = () => {

        /* Fields */
        const { status, data, page, count, number, startDate, endDate, savedOnly } = this.state
        const { openGame, postfix } = this.props


        return (
            <div className="multipoker--game-list puntobanco--game-list">

                <GameFilter
                    status={status}
                    number={number}
                    saved={savedOnly}
                    start={startDate}
                    end={endDate}
                    onNumber={(number) => this.setNumber(number)}
                    onSaved={(savedOnly) => this.setState({ savedOnly }, () => this.load(1, true))}
                    onFilter={(patch) => this.setState(patch, () => this.load(1, true))}
                    submit={() => this.load(1, true)}
                    reload={() => this.load(1, true)}
                />

                {/* The bar above stays in place while the rounds are being read */}
                {status === "ok" &&
                    <GameList
                        columns={COLUMNS()}
                        data={data}
                        page={page}
                        count={count}
                        postfix={postfix}
                        onOpen={(item) => openGame(item.id, item.number)}
                        onPage={(value) => this.load(value, true)}
                    />
                }

                {status !== "ok" && <Layout status={status} reload={() => this.load(1, true)} inner />}

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Games)
